import { ElementType } from "react";
import {
  Route,
  Switch,
  Redirect,
  useRouteMatch,
  NavLink,
} from "react-router-dom";
import { SettingOutlined, PhoneOutlined } from "@ant-design/icons";
import IconFont from "@/component/iconFont";
import loadable from "@/component/loadable";
import styles from "./../../page/my/style.module.less";

const Maintain = loadable(() => import("../../page/maintain")); // 系统维护

const Planning = loadable(() => import("@/page/planning"));
const PlanningAnchor = loadable(() => import("@/page/planning/anchor"));
const Game = loadable(() => import("@/page/game"));
const My = loadable(() => import("@/page/my"));
const Operate = loadable(() => import("@/page/operate"));
// const AccMy = loadable(() => import("@/page/accMy"));
const LoginService = loadable(() => import("@/page/login/loginService"));
const Login = loadable(() => import("@/page/login"));
const WorkShop = loadable(() => import("@/page/workshop"));
const SubAcc = loadable(() => import("@/page/subacc"));

// const Order = loadable(() => import("../../page/my/order"));
// const OrderConfirm = loadable(() => import("../../page/my/confirm"));
// const OrderUpload = loadable(
//   () => import("../../page/my/../../page/my/upload")
// );
const Detail = loadable(() => import("../../page/my/../../page/my/detail"));
const DetailBefore = loadable(
  () => import("../../page/my/../../page/my/before")
);
const Setting = loadable(() => import("../../page/my/setting"));
const Certification = loadable(() => import("../../page/my/certification"));
// const OnlineSpin = loadable(() => import("../../page/my/onlineSpin"));
const Contract = loadable(() => import("../../page/my/contract"));
const Assist = loadable(() => import("../../page/my/assist"));
// const Customer = loadable(() => import("../../page/my/customer"));
const Password = loadable(() => import("../../page/my/password"));
const BindPhone = loadable(() => import("../../page/my/bindPhone"));
const Manage = loadable(() => import("../../page/my/manage"));
const PmtList = loadable(() => import("../../page/my/promotionList"));
const PmtData = loadable(() => import("../../page/my/promotionData"));

const {
  accountType,
  accountLevel,
  supportAssist,
  mainId,
  supportMarketing = 0,
  businessType,
  displayType = 0,
} = JSON.parse(localStorage.getItem("user") || "{}");

const accType = (function () {
  if (accountLevel === 0 && (accountType === 0 || accountType === 1 || accountType === 4) && displayType === 1) return 5; // 商务（子）账号
  if ( accountLevel === 0 && (accountType === 0 || accountType === 1 || accountType === 4) ) return 0; // 普通（子）账号
  if (accountLevel === 1 && (accountType === 0 || accountType === 1)) return 1; // 对账账号
  if (accountLevel === 2 && (accountType === 0 || accountType === 1)) return 2; // 主账号
  if (accountLevel === 1 && accountType === 3) return 3; // 外放渠道账号
  if (businessType === 3 && accountLevel === 2 && (accountType === 0 || accountType === 1)) return 4; // 联运主账号
})();

// 0：普通用户，1：对账账号，2：主账号
const switchMyRightType = () => {
  const { path } = useRouteMatch();

  if (accountType === 2) {
    return <></>;
  }

  switch (accType) {
    case 0:
      return (
        <Switch>
          {/* <Route exact path={`${path}/order`} component={Order} /> */}
          {/* <Route
            exact
            path={`${path}/order/confirm/:id`}
            component={OrderConfirm}
          />
          <Route
            exact
            path={`${path}/order/upload/:id`}
            component={OrderUpload}
          /> */}
          <Route exact path={`${path}/detail`} component={Detail} />
          <Route
            exact
            path={`${path}/detail/before`}
            component={DetailBefore}
          />
          <Route path={`${path}/setting`} component={Setting} />
          <Route path={`${path}/certification`} component={Certification} />
          {/* <Route exact path={`${path}/onlineSpin`} component={OnlineSpin} /> */}
          <Route
            exact
            path={`${path}/onlineSpin/contract`}
            component={Contract}
          />
          <Route path={`${path}/assist`} component={Assist} />
          {/* {!window.isShunwan && (
            <Route path={`${path}/customer`} component={Customer} />
          )} */}
          <Route path={`${path}/password`} component={Password} />
          <Route path={`${path}/bindPhone`} component={BindPhone} />
          <Redirect to={`${path}/detail`} />
        </Switch>
      );
    case 1:
      return (
        <Switch>
          <Route path={`${path}/setting`} component={Setting} />
          <Route path={`${path}/password`} component={Password} />
          <Route path={`${path}/bindPhone`} component={BindPhone} />
          {/* {!window.isShunwan && (
            <Route path={`${path}/customer`} component={Customer} />
          )} */}
          <Redirect to={`${path}/setting`} />
        </Switch>
      );
    case 2:
      return (
        <Switch>
          {/* <Route exact path={`${path}/order/:id`} component={Order} /> */}
          <Route path={`${path}/setting`} component={Setting} />
          <Route exact path={`${path}/manage`} component={Manage} />
          <Route path={`${path}/password`} component={Password} />
          <Route path={`${path}/bindPhone`} component={BindPhone} />
          {/* {!window.isShunwan && (
            <Route path={`${path}/customer`} component={Customer} />
          )} */}
          <Redirect to={`${path}/setting`} />
        </Switch>
      );
    case 3:
      return (
        <Switch>
          <Route exact path={`${path}/promotionList`} component={PmtList} />
          <Route exact path={`${path}/promotionData`} component={PmtData} />
        </Switch>
      );
    case 5:
      return (
        <Switch>
          <Route exact path={`${path}/detail`} component={Detail} />
          <Route
            exact
            path={`${path}/detail/before`}
            component={DetailBefore}
          />
        </Switch>
      );
    default:
      return (
        <Switch>
          {/* <Route exact path={`${path}/order`} component={Order} /> */}
          {/* <Route
            exact
            path={`${path}/order/confirm/:id`}
            component={OrderConfirm}
          />
          <Route
            exact
            path={`${path}/order/upload/:id`}
            component={OrderUpload}
          /> */}
          <Route exact path={`${path}/detail`} component={Detail} />
          <Route
            exact
            path={`${path}/detail/before`}
            component={DetailBefore}
          />
          <Route path={`${path}/setting`} component={Setting} />
          <Route path={`${path}/certification`} component={Certification} />
          {/* <Route exact path={`${path}/onlineSpin`} component={OnlineSpin} /> */}
          <Route
            exact
            path={`${path}/onlineSpin/contract`}
            component={Contract}
          />
          {/* {!window.isShunwan && (
            <Route path={`${path}/customer`} component={Customer} />
          )} */}
          <Route path={`${path}/password`} component={Password} />
          <Route path={`${path}/bindPhone`} component={BindPhone} />
          <Redirect to={`${path}/detail`} />
        </Switch>
      );
  }
};

const switchMyLeftType = () => {
  const { path } = useRouteMatch();

  if (accountType === 2) {
    return <></>;
  }

  switch (accType) {
    case 0:
      return (
        <>
          {/* <NavLink activeClassName={styles.active} to={`${path}/order`}>
            <IconFont type="icon-tixianmingxi" />
            <span>提现明细</span>
          </NavLink> */}
          <NavLink activeClassName={styles.active} to={`${path}/detail`}>
            <IconFont type="icon-yongjinmingxi" />
            <span>数据查看</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/setting`}>
            <IconFont type="icon-wanshanziliao" />
            <span>账号信息</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/certification`}>
            <IconFont type="icon-zizhirenzheng" />
            <span>资质认证</span>
          </NavLink>
          {/* <NavLink activeClassName={styles.active} to={`${path}/onlineSpin`}>
            <IconFont type="icon-hetongguanli" />
            <span>合同管理</span>
          </NavLink> */}
          {supportAssist === 1 ? (
            <NavLink activeClassName={styles.active} to={`${path}/assist`}>
              <IconFont type="icon-fulishenqing" />
              <span>福利申请</span>
            </NavLink>
          ) : null}
          {/* {!mainId && !window.isShunwan && (
            <NavLink activeClassName={styles.active} to={`${path}/customer`}>
              <IconFont type="icon-zhuanshukefu" />
              <span>专属客服</span>
            </NavLink>
          )} */}
          <NavLink activeClassName={styles.active} to={`${path}/password`}>
            <SettingOutlined width={20} />
            <span>密码设置</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/bindPhone`}>
            <PhoneOutlined width={20} />
            <span>绑定手机</span>
          </NavLink>
        </>
      );
    case 1:
      return (
        <>
          <NavLink activeClassName={styles.active} to={`${path}/setting`}>
            <IconFont type="icon-wanshanziliao" />
            <span>账号信息</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/password`}>
            <SettingOutlined width={20} />
            <span>密码设置</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/bindPhone`}>
            <PhoneOutlined width={20} />
            <span>绑定手机</span>
          </NavLink>
          {/* {!window.isShunwan && (
            <NavLink activeClassName={styles.active} to={`${path}/customer`}>
              <IconFont type="icon-zhuanshukefu" />
              <span>专属客服</span>
            </NavLink>
          )} */}
        </>
      );
    case 2:
      return (
        <>
          <NavLink activeClassName={styles.active} to={`${path}/setting`}>
            <IconFont type="icon-wanshanziliao" />
            <span>账号信息</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/manage`}>
            <IconFont type="icon-wanshanziliao" />
            <span>账号管理</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/password`}>
            <SettingOutlined width={20} />
            <span>密码设置</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/bindPhone`}>
            <PhoneOutlined width={20} />
            <span>绑定手机</span>
          </NavLink>
          {/* {!window.isShunwan && (
            <NavLink activeClassName={styles.active} to={`${path}/customer`}>
              <IconFont type="icon-zhuanshukefu" />
              <span>专属客服</span>
            </NavLink>
          )} */}
        </>
      );
    case 3:
      return (
        <>
          <NavLink activeClassName={styles.active} to={`${path}/promotionList`}>
            <IconFont type="icon-tixianmingxi" />
            <span>每日报表</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/promotionData`}>
            <IconFont type="icon-yongjinmingxi" />
            <span>数据明细</span>
          </NavLink>
        </>
      );
    case 5:
      return (
        <>
          <NavLink activeClassName={styles.active} to={`${path}/detail`}>
            <IconFont type="icon-yongjinmingxi" />
            <span>数据查看</span>
          </NavLink>
        </>
      );
    default:
      return (
        <>
          {/* <NavLink activeClassName={styles.active} to={`${path}/order`}>
            <IconFont type="icon-tixianmingxi" />
            <span>提现明细</span>
          </NavLink> */}
          <NavLink activeClassName={styles.active} to={`${path}/detail`}>
            <IconFont type="icon-yongjinmingxi" />
            <span>数据查看</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/setting`}>
            <IconFont type="icon-wanshanziliao" />
            <span>账号信息</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/certification`}>
            <IconFont type="icon-zizhirenzheng" />
            <span>资质认证</span>
          </NavLink>
          {/* <NavLink activeClassName={styles.active} to={`${path}/onlineSpin`}>
            <IconFont type="icon-hetongguanli" />
            <span>合同管理</span>
          </NavLink> */}
          {/* {!window.isShunwan && (
            <NavLink activeClassName={styles.active} to={`${path}/customer`}>
              <IconFont type="icon-zhuanshukefu" />
              <span>专属客服</span>
            </NavLink>
          )} */}
          <NavLink activeClassName={styles.active} to={`${path}/password`}>
            <SettingOutlined width={20} />
            <span>密码设置</span>
          </NavLink>
          <NavLink activeClassName={styles.active} to={`${path}/bindPhone`}>
            <PhoneOutlined width={20} />
            <span>绑定手机</span>
          </NavLink>
        </>
      );
  }
};

// 主路由
const switchUserType = () => {
  if (accountType === 2) {
    return (
      <Switch>
        <Route path="/planning/anchor" component={PlanningAnchor}></Route>
        <Route exact path="/login" component={Login}></Route>
        <Redirect to={"/planning/anchor"} />
      </Switch>
    );
  }

  switch (accType) {
    case 0:
      return (
        <Switch>
          <Route path="/planning" component={Planning}></Route>
          <Route exact path="/game" component={Game}></Route>
          <Route path="/my" component={My}></Route>
          <Route
            exact
            path="/login/loginService"
            component={LoginService}
          ></Route>
          <Route exact path="/login" component={Login}></Route>
          <Redirect to={"/planning/signboard"} />
        </Switch>
      );
    case 1:
      return (
        <Switch>
          <Route path="/my" component={My}></Route>
          <Route exact path="/subacc" component={SubAcc}></Route>
          <Route
            exact
            path="/login/loginService"
            component={LoginService}
          ></Route>
          <Route exact path="/login" component={Login}></Route>
          <Redirect to={"/subacc"} />
        </Switch>
      );
    case 2:
      return (
        <Switch>
          <Route path="/my" component={My}></Route>
          <Route
            exact
            path="/login/loginService"
            component={LoginService}
          ></Route>
          <Route exact path="/login" component={Login}></Route>
          <Route exact path="/workshop" component={WorkShop}></Route>
          <Route path="/planning" component={Planning}></Route>
          <Route exact path="/game" component={Game}></Route>
          <Route exact path="/subacc" component={SubAcc}></Route>
          <Route path="/operate" component={Operate}></Route>
          <Redirect to={"/workshop"} />
        </Switch>
      );
    case 3:
      return (
        <Switch>
          <Route path="/my" component={My}></Route>
          <Route
            exact
            path="/login/loginService"
            component={LoginService}
          ></Route>
          <Route exact path="/login" component={Login}></Route>
          <Redirect to={"/my"} />
        </Switch>
      );
    case 5:
      return (
        <Switch>
          <Route path="/planning" component={Planning}></Route>
          <Route path="/my" component={My}></Route>
          <Route
            exact
            path="/login/loginService"
            component={LoginService}
          ></Route>
          <Route exact path="/login" component={Login}></Route>
          <Redirect to={"/my"} />
        </Switch>
      );
    default:
      return (
        <Switch>
          <Route path="/planning" component={Planning}></Route>
          <Route exact path="/game" component={Game}></Route>
          <Route path="/my" component={My}></Route>
          <Route
            exact
            path="/login/loginService"
            component={LoginService}
          ></Route>
          <Route exact path="/login" component={Login}></Route>
          <Redirect to={"/planning/signboard"} />
        </Switch>
      );
  }
};

// 顶部栏
const menus = () => {
  if (accountType === 2) {
    return [
      {
        key: "planning",
        title: "推广",
        icon: "icon-tuiguang",
      },
    ];
  }

  switch (accType) {
    case 0:
      return [
        {
          key: "planning",
          title: "推广",
          icon: "icon-tuiguang",
        },
        {
          key: "game",
          title: "找游",
          icon: "icon-zhaoyou",
        },
        {
          key: "my",
          title: "我的",
          icon: "icon-wode",
        },
      ];
    case 1:
      return [
        {
          key: "subacc",
          title: "子账号",
          icon: "icon-zizhanghao",
        },
        {
          key: "my",
          title: "我的",
          icon: "icon-wode",
        },
      ];
    case 2:
      const list = [
        {
          key: "workshop",
          title: "工作台",
          icon: "icon-gongzuotai",
        },
        {
          key: "subacc",
          title: "子账号",
          icon: "icon-zizhanghao",
        },
        {
          key: "operate",
          title: "运营",
          icon: "icon-yunying",
        },
        {
          key: "planning",
          title: "推广",
          icon: "icon-tuiguang",
        },
        {
          key: "game",
          title: "找游",
          icon: "icon-zhaoyou",
        },
        {
          key: "my",
          title: "我的",
          icon: "icon-wode",
        },
      ];
      if (supportMarketing === 0) list.splice(2, 1);
      return list;
    case 3:
      return [
        {
          key: "my",
          title: "我的",
          icon: "icon-wode",
        },
      ];
    case 4:
      return [
        {
          key: "workshop",
          title: "工作台",
          icon: "icon-gongzuotai",
        },
        {
          key: "subacc",
          title: "子账号",
          icon: "icon-zizhanghao",
        },
        {
          key: "operate",
          title: "运营",
          icon: "icon-yunying",
        },
        {
          key: "planning",
          title: "推广",
          icon: "icon-tuiguang",
        },
      ];
    case 5:
      return [
        {
          key: "planning",
          title: "推广",
          icon: "icon-tuiguang",
        },
        {
          key: "my",
          title: "我的",
          icon: "icon-wode",
        },
      ];
    default:
      return [
        {
          key: "planning",
          title: "推广",
          icon: "icon-tuiguang",
        },
        {
          key: "game",
          title: "找游",
          icon: "icon-zhaoyou",
        },
        {
          key: "my",
          title: "我的",
          icon: "icon-wode",
        },
      ];
  }
};

export default function HocPageAuthority(Component: ElementType) {
  return function HOCPageAuthorityComponent(props: any) {
    return (
      <Component
        menusTpye={menus}
        switchUserType={switchUserType}
        switchMyRightType={switchMyRightType}
        switchMyLeftType={switchMyLeftType}
        isAffiliate={accType === 3}
        {...props}
      />
    );
  };
}
